module.exports = __webpack_public_path__ + "static/media/24-7-call.29f14743.svg";